import { i18n } from "@/i18n";

export default {
  path: "/dashboard",
  name: "DashboardLayout",
  redirect: "home",
  component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/DashboardLayoutView.vue"),
  meta: {
    authRequired: true,
    breadcrumb: true,
    title: i18n.global.t("page.home"),
  },
  children: [
    {
      path: "home",
      name: "Dashboard",
      component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/DashboardView.vue"),
      meta: {
        title: i18n.global.t("page.dashboard"),
        breadcrumb: false,
      },
    },
    {
      path: "missions",
      name: "dashboardMission",
      component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/DashboardView.vue"),
      meta: {
        title: i18n.global.t("page.dashboard"),
        breadcrumb: false,
      },
    },
    {
      path: "skills",
      name: "dashboardSkill",
      component: () => import(/* webpackChunkName: "global" */ "@/views/Global/GlobalLayoutView.vue"),
      redirect: { name: "MODULE_STUDEA_SKILL" },
      meta: {
        title: i18n.global.t("page.skills"),
        code: "MODULE_STUDEA_SKILL",
        breadcrumb: true,
        help: true,
      },
      children: [
        {
          path: "",
          name: "MODULE_STUDEA_SKILL",
          component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Skill/SkillsView.vue"),
          meta: {
            title: i18n.global.t("page.skills"),
            code: "MODULE_STUDEA_SKILL",
            breadcrumb: false,
            help: true,
          },
        },
        {
          path: "stats",
          name: "skillsStats",
          component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Skill/SkillsStatsView.vue"),
          meta: {
            title: i18n.global.t("page.skills_stats"),
            breadcrumb: true,
          },
        },
        {
          path: "synthesis",
          name: "skillsSynthesis",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Skill/SkillsSynthesisView.vue"),
          meta: {
            title: i18n.global.t("page.skills_synthesis"),
            breadcrumb: true,
          },
        },
      ],
    },
    {
      path: "weblinks",
      name: "MODULE_STUDEA_WEBLINKS",
      component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/WeblinksView.vue"),
      meta: {
        title: i18n.global.t("page.weblinks"),
        code: "MODULE_STUDEA_WEBLINKS",
        breadcrumb: true,
        help: true,
      },
    },
    {
      path: "gradebook",
      name: "MODULE_STUDEA_GRADEBOOK",
      component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/GradebookView.vue"),
      meta: {
        title: i18n.global.t("page.gradebook"),
        code: "MODULE_STUDEA_GRADEBOOK",
        breadcrumb: true,
        help: true,
      },
    },
    {
      path: "attestations",
      name: "attestations",
      component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/AttestationsView.vue"),
      meta: {
        title: i18n.global.t("page.attestations"),
        code: "attestations",
        breadcrumb: true,
        help: true,
      },
    },
    {
      path: "message",
      name: "MODULE_STUDEA_MESSAGE",
      component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Chat/ChatView.vue"),
      meta: {
        title: i18n.global.t("page.message"),
        breadcrumb: true,
        code: "MODULE_STUDEA_MESSAGE",
        help: true,
      },
      children: [
        {
          path: ":id",
          name: "showMessage",
          component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Chat/ChatView.vue"),
          meta: {
            title: i18n.global.t("page.message"),
            breadcrumb: false,
            forceFetchOnMagicLink: true,
          },
        },
        {
          path: "new",
          name: "newMessage",
          component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Chat/ChatView.vue"),
          meta: {
            title: i18n.global.t("page.new_message"),
            breadcrumb: true,
          },
        },
      ],
    },
    {
      path: "document",
      name: "MODULE_STUDEA_DOCUMENT",
      component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Document/DocumentView.vue"),
      meta: {
        title: i18n.global.t("page.document"),
        breadcrumb: true,
        help: true,
        code: "MODULE_STUDEA_DOCUMENT",
      },
      children: [
        {
          path: ":alias(add)/doc",
          name: "dashboardAddDoc",
          component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Document/DocumentView.vue"),
          meta: {
            title: i18n.global.t("page.document_add"),
            breadcrumb: true,
            help: false,
            key: "documents",
          },
        },
      ],
    },
    {
      path: "notepad",
      name: "MODULE_STUDEA_NOTEPAD",
      component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Notepad/NotepadView.vue"),
      meta: {
        title: i18n.global.t("page.notepad"),
        breadcrumb: true,
        help: true,
        code: "MODULE_STUDEA_NOTEPAD",
      },
    },
    {
      path: "lessons",
      name: "MODULE_STUDEA_COURSE",
      component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/LessonView.vue"),
      meta: {
        title: i18n.global.t("page.lessons"),
        breadcrumb: true,
        help: true,
        code: "MODULE_STUDEA_COURSE",
      },
    },
    {
      path: "lesson/:id",
      name: "lesson",
      component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/LessonView.vue"),
      meta: {
        title: i18n.global.t("page.lessons"),
        breadcrumb: true,
        help: true,
      },
    },
    {
      path: "timetable",
      name: "MODULE_STUDEA_ABSENCE",
      redirect: { name: "absenceCalendar" },
      component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Absence/AbsenceLayoutView.vue"),
      meta: {
        title: i18n.global.t("page.timetable"),
        breadcrumb: true,
        code: "MODULE_STUDEA_ABSENCE",
      },
      children: [
        {
          path: "calendar",
          name: "absenceCalendar",
          component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Absence/AbsenceView.vue"),
          meta: {
            title: i18n.global.t("page.timetable"),
            breadcrumb: false,
            code: "timetable",
          },
        },
        {
          path: "list/absence",
          name: "absenceListEvent",
          component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Absence/AbsenceListView.vue"),
          meta: {
            title: i18n.global.t("absence.list_planning"),
            breadcrumb: true,
          },
        },
        {
          path: "list/absence/attestation",
          name: "attendanceCertificateListView",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Absence/AttendanceCertificateListView.vue"),
          meta: {
            title: i18n.global.t("absence.list_of_attendance_certificate"),
            breadcrumb: true,
          },
        },
      ],
    },
    {
      path: "questionnaire/:triadId/:questionnaireId",
      name: "questionnaire",
      component: () => import(/* webpackChunkName: "questionnaire" */ "@/views/Questionnaire/QuestionnaireView.vue"),
      meta: {
        title: i18n.global.t("page.questionnaire"),
        breadcrumb: true,
        forceFetchOnMagicLink: true,
        code: "MODULE_STUDEA_QUESTIONNAIRE",
      },
    },
    {
      path: "training-course-list",
      name: "TrainingCourseList",
      component: () =>
        import(/* webpackChunkName: "training-course" */ "@/views/TrainingCourse/TrainingCourseListView.vue"),
      meta: {
        title: i18n.global.t("page.training_course_list"),
        breadcrumb: true,
        help: true,
      },
    },
    {
      path: "training-list",
      name: "TrainingList",
      component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/DashboardLayoutView.vue"),
      meta: {
        title: i18n.global.t("page.training_list"),
        breadcrumb: true,
      },
    },
    {
      path: "dashboard-news",
      name: "newsLayout",
      component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/DashboardLayoutView.vue"),
      redirect: { name: "adminNewsList" },
      meta: {
        title: i18n.global.t("admin.news.list.title"),
        breadcrumb: true,
      },
      children: [
        {
          path: "",
          name: "newsList",
          component: () => import(/* webpackChunkName: "news" */ "@/views/News/NewsListView.vue"),
          meta: {
            title: i18n.global.t("admin.news.list.title"),
            breadcrumb: false,
          },
        },
        {
          path: ":id",
          name: "newsShow",
          component: () => import(/* webpackChunkName: "news" */ "@/views/News/NewsView.vue"),
          meta: {
            title: i18n.global.t("admin.news.list.title"),
            breadcrumb: true,
          },
        },
      ],
    },
    {
      path: "driver-licence",
      name: "MODULE_STUDEA_DRIVER_LICENCE",
      component: () =>
        import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/DriverLicence/DriverLicenceView.vue"),
      meta: {
        title: i18n.global.t("page.driver_licence"),
        breadcrumb: true,
        help: true,
      },
    },
  ],
};
